import api from './client'
import type { RaceSummary, MemberRace, Award } from '../types'

export interface RacesResponse {
  summary: RaceSummary
  races: MemberRace[]
  season: string
}

export interface AwardsResponse {
  awards: Award[]
}

export async function getRaces(season?: string): Promise<RacesResponse> {
  const params = season ? { season } : {}
  const { data } = await api.get<RacesResponse>('/members/me/races', { params })
  return data
}

export async function getAwards(): Promise<AwardsResponse> {
  const { data } = await api.get<AwardsResponse>('/members/me/awards')
  return data
}
